import React from 'react';
import Box from '@material-ui/core/Box';
import { useTranslation } from '../../../hooks/useTranslation';
import { makeStyles, Theme } from '@material-ui/core/styles';
import {
  hasValidDigit,
  hasValidLength,
  hasValidLowerCase,
  hasValidUpperCase,
} from '../../../util/form-validation';
import CheckIcon from '@material-ui/icons/Check';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

const useStyles = makeStyles((theme: Theme) => ({
  requirementsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '4px 16px',

    // mobile: stack vertically
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  requirementItem: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 4, // or gap if you prefer and your browser support is ok
  },
  icon: {
    fontSize: '16px',
    color: theme.palette.success.main,
  },
  icon_invalid: {
    fontSize: '16px',
  },
}));

const PasswordHelper = ({ password }: { password: string }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const passwordRequirements = {
    hasLength: {
      isValid: hasValidLength(password),
      text: t('REGEX_LENGTH'),
    },
    hasUpperCase: {
      isValid: hasValidUpperCase(password),
      text: t('REGEX_UPPER'),
    },
    hasLowerCase: {
      isValid: hasValidLowerCase(password),
      text: t('REGEX_LOWER'),
    },
    hasDigit: {
      isValid: hasValidDigit(password),
      text: t('REGEX_DIGIT'),
    },
  };

  const getIcon = (isValid: boolean) =>
    isValid ? CheckIcon : RadioButtonUncheckedIcon;

  return (
    <Box className={classes.requirementsGrid}>
      {Object.values(passwordRequirements).map(({ isValid, text }, index) => {
        const Icon = getIcon(isValid);

        return (
          <Box
            className={classes.requirementItem}
            key={`text-${index.toString()}`}
          >
            <Icon
              className={isValid ? classes.icon : classes.icon_invalid}
              fontSize={'small'}
            />{' '}
            {text}
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordHelper;
